import { tenantRoutes } from './routes.tenant';

export const routes = [
    {
        component: () => import('./views/front/tickets/Submit.vue'),
        meta: {
            hideAppBar: true,
            requiresAuth: false,
        },
        name: 'front.tickets.submit',
        path: '/tickets/submit/:tenant',
    },
    {
        component: () => import('./views/front/worksheets/Sign.vue'),
        meta: {
            hideAppBar: true,
            requiresAuth: false,
        },
        name: 'front.worksheets.sign',
        path: '/worksheets/sign/:tenant/:worksheet',
    },
    {
        component: () => import('./views/tickets/Board.vue'),
        meta: {
            permission: 'tickets.index.all|tickets.index.owned|tickets.index.assigned',
            requiresAuth: true,
        },
        name: 'tickets',
        path: '/tickets',
    },
    {
        component: () => import('./views/auth/Register.vue'),
        meta: {
            requiresAuth: false,
        },
        name: 'register',
        path: '/register',
    },
    {
        component: () => import('./views/auth/Login.vue'),
        meta: {
            requiresAuth: false,
        },
        name: 'login',
        path: '/login/:token?',
    },
    {
        component: () => import('./views/auth/ForgotPassword.vue'),
        meta: {
            requiresAuth: false,
        },
        name: 'forgot-password',
        path: '/password/reset',
    },
    {
        component: () => import('./views/auth/ResetPasswordCode.vue'),
        meta: {
            requiresAuth: false,
        },
        name: 'password-email',
        path: '/password/email',
    },
    {
        component: () => import('./views/auth/ResetPassword.vue'),
        meta: {
            requiresAuth: false,
        },
        name: 'reset-password',
        path: '/password/reset/:token',
    },
    {
        component: () => import('./views/devices/pn/Index.vue'),
        meta: {
            permission: 'devices.index',
            requiresAuth: true,
        },
        name: 'devices.pn',
        path: '/devices/pn',
    },
    {
        component: () => import('./views/devices/pn/Create.vue'),
        meta: {
            permission: 'devices.store',
            requiresAuth: true,
        },
        name: 'devices.pn.create',
        path: '/devices/pn/create',
    },
    {
        component: () => import('./views/devices/pn/Edit.vue'),
        meta: {
            permission: 'devices.show|devices.update',
            requiresAuth: true,
        },
        name: 'devices.pn.edit',
        path: '/devices/pn/:pn/edit',
    },
    {
        component: () => import('./views/devices/sn/Create.vue'),
        meta: {
            permission: 'devices.store',
            requiresAuth: true,
        },
        name: 'devices.sn.create',
        path: '/devices/sn/create',
    },
    {
        component: () => import('./views/devices/sn/Edit.vue'),
        meta: {
            permission: 'devices.show|devices.update',
            requiresAuth: true,
        },
        name: 'devices.sn.edit',
        path: '/devices/sn/:sn/edit',
    },
    {
        component: () => import('./views/employees/Index.vue'),
        meta: {
            permission: 'users.index',
            requiresAuth: true,
        },
        name: 'employees',
        path: '/employees',
    },
    {
        component: () => import('./views/employees/Create.vue'),
        meta: {
            permission: 'users.store',
            requiresAuth: true,
        },
        name: 'employees.create',
        path: '/employees/create',
    },
    {
        component: () => import('./views/employees/Edit.vue'),
        meta: {
            permission: 'users.show|users.update',
            requiresAuth: true,
        },
        name: 'employees.edit',
        path: '/employees/:employee/edit',
    },
    {
        component: () => import('./views/inventory/Index.vue'),
        meta: {
            permission: 'inventory.index',
            requiresAuth: true,
        },
        name: 'inventory',
        path: '/inventory',
    },
    {
        component: () => import('./views/inventory/Create.vue'),
        meta: {
            permission: 'inventory.store',
            requiresAuth: true,
        },
        name: 'inventory.create',
        path: '/inventory/create',
    },
    {
        component: () => import('./views/inventory/Edit.vue'),
        meta: {
            permission: 'inventory.update',
            requiresAuth: true,
        },
        name: 'inventory.edit',
        path: '/inventory/:inventory/edit',
    },
    {
        component: () => import('./views/partners/Index.vue'),
        meta: {
            permission: 'partners.index',
            requiresAuth: true,
        },
        name: 'partners',
        path: '/partners',
    },
    {
        component: () => import('./views/partners/Create.vue'),
        meta: {
            permission: 'partners.store',
            requiresAuth: true,
        },
        name: 'partners.create',
        path: '/partners/create',
    },
    {
        component: () => import('./views/partners/Edit.vue'),
        meta: {
            permission: 'partners.show|partners.update',
            requiresAuth: true,
        },
        name: 'partners.edit',
        path: '/partners/:partner/edit',
    },
    {
        component: () => import('./views/partners/sites/Create.vue'),
        meta: {
            permission: 'partners.update',
            requiresAuth: true,
        },
        name: 'partners.sites.create',
        path: '/partners/:partner/sites/create',
    },
    {
        component: () => import('./views/partners/sites/Edit.vue'),
        meta: {
            permission: 'partners.update',
            requiresAuth: true,
        },
        name: 'partners.sites.edit',
        path: '/partners/:partner/sites/:site/edit',
    },
    {
        component: () => import('./views/partners/sites/contacts/Create.vue'),
        meta: {
            permission: 'partners.update',
            requiresAuth: true,
        },
        name: 'partners.sites.contacts.create',
        path: '/partners/:partner/sites/:site/contacts/create',
    },
    {
        component: () => import('./views/partners/sites/contacts/Edit.vue'),
        meta: {
            permission: 'partners.update',
            requiresAuth: true,
        },
        name: 'partners.sites.contacts.edit',
        path: '/partners/:partner/sites/:site/contacts/:contact/edit',
    },
    {
        component: () => import('./views/profile/Company.vue'),
        meta: {
            permission: 'profile.company.show',
            requiresAuth: true,
        },
        name: 'profile.company',
        path: '/profile/company',
    },
    {
        component: () => import('./views/profile/Settings.vue'),
        meta: {
            permission: 'profile.company.show',
            requiresAuth: true,
        },
        name: 'profile.settings',
        path: '/profile/settings',
    },
    {
        component: () => import('./views/profile/User.vue'),
        meta: {
            requiresAuth: true,
        },
        name: 'profile.user',
        path: '/profile',
    },
    {
        component: () => import('./views/reports/Index.vue'),
        meta: {
            permission: 'worksheets.inventory.index|worksheets.time.index',
            requiresAuth: true,
        },
        name: 'reports',
        path: '/reports',
    },
    {
        component: () => import('./views/reports/Capacity.vue'),
        meta: {
            permission: 'worksheets.time.index',
            requiresAuth: true,
        },
        name: 'reports.capacity',
        path: '/reports/capacity',
    },
    {
        component: () => import('./views/reports/Inventory.vue'),
        meta: {
            permission: 'worksheets.inventory.index',
            requiresAuth: true,
        },
        name: 'reports.inventory',
        path: '/reports/inventory',
    },
    {
        component: () => import('./views/reports/Time.vue'),
        meta: {
            permission: 'worksheets.time.index',
            requiresAuth: true,
        },
        name: 'reports.time',
        path: '/reports/time',
    },
    {
        component: () => import('./views/reports/Worksheets.vue'),
        meta: {
            permission: 'worksheets.index',
            requiresAuth: true,
        },
        name: 'reports.worksheets',
        path: '/reports/worksheets',
    },
    {
        component: () => import('./views/subscriptions/Billing.vue'),
        meta: {
            permission: 'subscriptions.manage',
            requiresAuth: true,
        },
        name: 'subscriptions.billing',
        path: '/subscriptions/billing',
    },
    {
        component: () => import('./views/subscriptions/ChangePlan.vue'),
        meta: {
            permission: 'subscriptions.manage',
            requiresAuth: true,
        },
        name: 'subscriptions.change-plan',
        path: '/subscriptions/change-plan',
    },
    {
        component: () => import('./views/subscriptions/Subscribe.vue'),
        meta: {
            permission: 'subscriptions.manage',
            requiresAuth: true,
        },
        name: 'subscriptions.subscribe',
        path: '/subscriptions/subscribe',
    },
    {
        component: () => import('./views/subscriptions/UpdatePaymentMethod.vue'),
        meta: {
            permission: 'subscriptions.manage',
            requiresAuth: true,
        },
        name: 'subscriptions.update-payment-method',
        path: '/subscriptions/update-payment-method',
    },
    {
        component: () => import('./views/tickets/Me.vue'),
        meta: {
            permission: 'tickets.index.all|tickets.index.owned',
            requiresAuth: true,
        },
        name: 'tickets.me',
        path: '/tickets/me',
    },
    {
        component: () => import('./views/tickets/MeEdit.vue'),
        meta: {
            permission: 'tickets.update.all|tickets.update.owned',
            requiresAuth: true,
        },
        name: 'tickets.me.edit',
        path: '/tickets/:ticket/me',
    },
    {
        component: () => import('./views/tickets/Archive.vue'),
        meta: {
            permission: 'tickets.archive.index.all|tickets.archive.index.owned',
            requiresAuth: true,
        },
        name: 'tickets.archive',
        path: '/tickets/archive',
    },
    {
        component: () => import('./views/tickets/Create.vue'),
        meta: {
            permission: 'tickets.store',
            requiresAuth: true,
        },
        name: 'tickets.create',
        path: '/tickets/create',
    },
    {
        component: () => import('./views/tickets/Edit.vue'),
        meta: {
            permission: 'tickets.update.all|tickets.update.owned|tickets.update.assigned',
            requiresAuth: true,
        },
        name: 'tickets.edit',
        path: '/tickets/:ticket/edit',
    },
    {
        component: () => import('./views/worksheets/Edit.vue'),
        meta: {
            permission: 'worksheets.update',
            requiresAuth: true,
        },
        name: 'worksheets.edit',
        path: '/worksheets/:worksheet/edit',
    },
    {
        component: () => import('./views/worksheets/Show.vue'),
        meta: {
            permission: 'worksheets.show',
            requiresAuth: true,
        },
        name: 'worksheets.show',
        path: '/worksheets/:worksheet',
    },
    {
        component: () => import('./views/worksheets/sn/note/Edit.vue'),
        meta: {
            permission: 'worksheets.update',
            requiresAuth: true,
        },
        name: 'worksheets.sn.note',
        path: '/worksheets/:worksheet/sn/:sn/note',
    },
    {
        component: () => import('./views/worksheets/tasks/note/Edit.vue'),
        meta: {
            permission: 'worksheets.update',
            requiresAuth: true,
        },
        name: 'worksheets.tasks.note',
        path: '/worksheets/:worksheet/tasks/:task/note',
    },
    {
        component: () => import('./views/worksheets/time/Edit.vue'),
        meta: {
            permission: 'worksheets.update',
            requiresAuth: true,
        },
        name: 'worksheets.time',
        path: '/worksheets/:worksheet/time',
    },
    {
        component: () => import('./views/errors/402.vue'),
        name: 'errors.402',
        path: '/payment-required',
    },
    {
        component: () => import('./views/errors/403.vue'),
        name: 'errors.403',
        path: '/unauthorized',
    },
    {
        component: () => import('./views/errors/404.vue'),
        meta: {
            requiresAuth: false,
        },
        name: 'errors.404',
        path: '/not-found',
    },
    {
        component: () => import('./views/errors/404.vue'),
        meta: {
            requiresAuth: false,
        },
        name: 'errors.catch-all',
        path: '/:pathMatch(.*)*',
    },
    ...tenantRoutes,
];
